//NOTE autogenerated by export script
import { PandoraCollarKeysAPIService as PandoraCollarKeysAPIServiceType } from './pandoraCollarKeysAPI.service'
export const PandoraCollarKeys: typeof PandoraCollarKeysAPIServiceType = {} as any
import { PasiphaeGeneratedScheduleFilesAPIService as PasiphaeGeneratedScheduleFilesAPIServiceType } from './pasiphaeGeneratedScheduleFilesAPI.service'
export const PasiphaeGeneratedScheduleFiles: typeof PasiphaeGeneratedScheduleFilesAPIServiceType = {} as any
import { ProductionTestFilesAPIService as ProductionTestFilesAPIServiceType } from './productionTestFilesAPI.service'
export const ProductionTestFiles: typeof ProductionTestFilesAPIServiceType = {} as any
export {BASE_PATH} from '../variables'
import { ApiModule as ApiModuleType } from '../api.module'
export const ApiModule: typeof ApiModuleType = {} as any
import { AllServices as AllServicesType } from './allService'
export const All: typeof AllServicesType = {} as any